// Higher order component for rights checking components. Wrap the connect function
// of any component that needs to check rights with RightsChecker. Look
// at CatalogGridItem or CatalogRowItem for examples.

import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getInDomain } from '../../domains/externalUtils';

export const mapStateToProps = (state, ownProps) => {
  const props = {};
  props.pandoraId = ownProps.id;
  props.blankItem = ownProps.blankItem;
  props.isRightsInfoExpired = getInDomain('catalog.utils.getIsRightsInfoExpired', false)(
    state,
    props.pandoraId,
  );
  return props;
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      refreshAnnotations: getInDomain('catalog.actions.refreshAnnotations', noop),
    },
    dispatch,
  );
};

export default function RightsChecker(ComposedComponent) {
  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(
    class extends React.Component {
      static propTypes = {
        pandoraId: PropTypes.string,
        refreshAnnotations: PropTypes.func,
        blankItem: PropTypes.bool,
        isRightsInfoExpired: PropTypes.bool,
      };

      componentWillMount() {
        this.checkRefreshAnnotations();
      }

      checkRefreshAnnotations = () => {
        if (!this.props.blankItem && this.props.isRightsInfoExpired) {
          this.props.refreshAnnotations(this.props.pandoraId);
        }
      };

      render() {
        return (
          <ComposedComponent {...this.props} rightsCheckerFunc={this.checkRefreshAnnotations} />
        );
      }
    },
  );
}
